import { Component, input, output } from '@angular/core';
import { HasPermissionDirective } from '@core/directives/has-permission.directive';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { EPermissions } from '@shared/enums/permissions.enum';
import { ISettingsSidebarItem, TSettingsTab } from './settings-sidebar.interface';

@Component({
  imports: [HasPermissionDirective, TranslateModule, IconComponent],
  selector: 'app-settings-sidebar',
  styleUrls: ['./settings-sidebar.component.scss'],
  templateUrl: './settings-sidebar.component.html',
})
export class SettingsSidebarComponent {
  public readonly activeTab = input.required<TSettingsTab>();
  public readonly tabSelected = output<TSettingsTab>();

  public readonly items: ISettingsSidebarItem[] = [
    {
      icon: '/icons/users-group.svg',
      id: 'userManagement',
      labelKey: 'pages.settings.userManagement.title',
      permissionGroups: [[EPermissions.userGroupDeleteMemberOwn]],
    },
    {
      icon: '/icons/template.svg',
      id: 'globalTemplates',
      labelKey: 'pages.settings.templateSettings.title',
      permissionGroups: [[EPermissions.campaignCreate]],
    },
  ];

  public onItemClick(id: TSettingsTab): void {
    this.tabSelected.emit(id);
  }
}
